export enum FilterNumberMode {
  From,
  Until,
  Between,
}
